import { IBankAccount } from '@monofront/types';
import { useTranslations } from 'next-intl';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';

interface IBankAccountRowProps {
  paymentMethod: IBankAccount;
  tags?: React.ReactElement<any>[];
}

const BankAccountRow: React.FC<IBankAccountRowProps> = ({
  paymentMethod,
  tags,
}) => {
  const tAccount = useTranslations('Account');

  return (
    <span className="bank-account-row tw-flex tw-items-center">
      <span className="brand-image tw-mr-4 tw-px-1 tw-pt-1">
        <ResponsiveImage
          src="/images/checkout/bank.svg"
          alt=""
          width={22}
          height={22}
          aria-hidden="true"
        />
      </span>
      <span className="details">
        <span className="numbers tw-mr-2">
          {tAccount('ibanDetails', { last4: paymentMethod.last4 })}
        </span>
        {tags && tags?.length > 0 && (
          <span className="tags">{tags.map((TagElement) => TagElement)}</span>
        )}
      </span>
    </span>
  );
};

export default BankAccountRow;
